import { Button } from "@/components/ui/button";
import { ArrowRight, Monitor, Server, Smartphone, Cpu } from "lucide-react";
import { Link } from "react-router-dom";
import SocialLinks from "./SocialLinks";
import { useTranslation } from "react-i18next";
import { trackButtonClick } from "@/utils/analytics";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 hero-gradient">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="gap-y-6 animate-fade-up">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              <span className="block">{t("hero.title")}</span>
              <span className="bg-gradient-to-r from-brand-black to-brand-yellow bg-clip-text text-transparent">
                {t("hero.subtitle")}
              </span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-lg">
              {t("hero.description")}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Button
                size="lg"
                className="bg-brand-black hover:bg-brand-black/90 text-brand-yellow"
                asChild
                onClick={() => trackButtonClick('explore_portfolio', 'hero')}
              >
                <Link to="/portfolio">
                  {t("hero.exploreServices")}
                  <ArrowRight className="ml-2 h-4 w-4 rtl:rotate-180" />
                </Link>
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-brand-yellow text-brand-black hover:bg-brand-yellow/10"
                onClick={() => trackButtonClick('contact_us', 'hero')}
              >
                <a href="/contact">{t("hero.contactUs")}</a>
              </Button>
            </div>

            <div className="pt-4">
              <a
                href="https://www.instagram.com/prebitit/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
              >
                <SocialLinks variant="large" iconSize={24} />
                <span className="font-medium">{t("hero.followUs")}</span>
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 animate-fade-in">
            <Link to='/services/websites' className="service-card flex flex-col items-center text-center gap-4">
              <div className="w-12 h-12 rounded-full bg-brand-yellow/10 flex items-center justify-center">
                <Monitor className="h-6 w-6 text-brand-black" />
              </div>
              <span className="font-medium text-base">{t("hero.services.websites")}</span>
              <p className="text-sm text-muted-foreground">
                {t("hero.services.websitesDesc")}
              </p>
            </Link>

            <Link to='/services/apps' className="service-card flex flex-col items-center text-center gap-4">
              <div className="w-12 h-12 rounded-full bg-brand-black/10 flex items-center justify-center">
                <Smartphone className="h-6 w-6 text-brand-yellow" />
              </div>
              <span className="font-medium text-base">{t("hero.services.apps")}</span>
              <p className="text-sm text-muted-foreground">
                {t("hero.services.appsDesc")}
              </p>
            </Link>

            <Link to='/services/ai' className="service-card flex flex-col items-center text-center gap-4">
              <div className="w-12 h-12 rounded-full bg-brand-yellow/10 flex items-center justify-center">
                <Server className="h-6 w-6 text-brand-black" />
              </div>
              <span className="font-medium text-base">{t("hero.services.ai")}</span>
              <p className="text-sm text-muted-foreground">
                {t("hero.services.aiDesc")}
              </p>
            </Link>

            <Link to='/services/pc' className="service-card flex flex-col items-center text-center gap-4">
              <div className="w-12 h-12 rounded-full bg-brand-black/10 flex items-center justify-center">
                <Cpu className="h-6 w-6 text-brand-yellow" />
              </div>
              <span className="font-medium text-base">{t("hero.services.pc")}</span>
              <p className="text-sm text-muted-foreground">
              {t("hero.services.pcDesc")}
              </p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
